const DEFAULT_FIELDS = ['hasService', 'index', 'productLine']

const serviceIdToColumnBase = serviceId =>
  serviceId.replace('program:', 'programs.').replace(':service:', '.services.')

const byServiceIdAsc = (a, b) => a.localeCompare(b)

const isWarehouseService = serviceId => serviceIdToColumnBase(serviceId).includes('.warehouse')

const normalizeServiceIds = (serviceIds = [], { excludeWarehouse = true, sort = 'serviceIdAsc' } = {}) => {
  const filtered = Array.from(new Set(serviceIds))
    .filter(Boolean)
    .filter(serviceId => !excludeWarehouse || !isWarehouseService(serviceId))

  if (sort === 'serviceIdAsc') {
    return filtered.sort(byServiceIdAsc)
  }

  if (typeof sort === 'function') {
    return filtered.sort(sort)
  }

  return filtered
}

const getServiceIdsFromConfigurationDocs = (configurationDocs = [], opts = {}) => {
  const serviceIds = configurationDocs.map(doc => doc.service)
  return normalizeServiceIds(serviceIds, opts)
}

const getServiceFromProduct = (product, serviceId) => {
  const services = product && Array.isArray(product.services) ? product.services : []
  return services.find(service => service.id === serviceId)
}

const getHasServiceValue = service => (service ? 'YES' : '')

const getFieldValue = (service, field) => {
  if (!service) return ''
  return service[field] === undefined ? '' : service[field]
}

const buildServiceColumns = (serviceIds = [], {
  excludeWarehouse = true,
  sort = 'serviceIdAsc',
  fields = DEFAULT_FIELDS
} = {}) => {
  const normalizedServiceIds = normalizeServiceIds(serviceIds, { excludeWarehouse, sort })
  const additionalColumns = {}

  for (const serviceId of normalizedServiceIds) {
    const servicePath = serviceIdToColumnBase(serviceId)

    for (const field of fields) {
      const key = `${servicePath}.${field}`

      additionalColumns[key] = {
        title: key,
        transform: product => {
          const service = getServiceFromProduct(product, serviceId)
          if (field === 'hasService') {
            return getHasServiceValue(service)
          }
          return getFieldValue(service, field)
        }
      }
    }
  }

  return additionalColumns
}

module.exports = {
  DEFAULT_FIELDS,
  serviceIdToColumnBase,
  getServiceIdsFromConfigurationDocs,
  buildServiceColumns
}
